import React, { useState, useEffect } from "react";
import { useQuery, useMutation } from "@apollo/client";
import { GET_ALL_DISHES } from "../../dish/gql/queries";
import { UPDATE_MIQAAT_MENU } from "../gql/mutations";

const MiqaatMenuForm = ({ miqaat, onClose, refetch }) => {
    const [menuItems, setMenuItems] = useState([]);
    const [searchTerms, setSearchTerms] = useState([]);
    const [activeDropdown, setActiveDropdown] = useState(null);
    const { data: dishesData } = useQuery(GET_ALL_DISHES);
    const dishes = dishesData?.dishes || [];
    
    const [updateMiqaatMenu] = useMutation(UPDATE_MIQAAT_MENU);

    useEffect(() => {
        if (miqaat.menu && miqaat.menu.length > 0) {
            const dishIds = miqaat.menu.map(dish => dish._id);
            setMenuItems(dishIds);
            setSearchTerms(miqaat.menu.map(dish => dish.dishName));
        } else {
            setMenuItems(['']);
            setSearchTerms(['']);
        }
    }, [miqaat]);

    const addRow = () => {
        setMenuItems([...menuItems, '']);
        setSearchTerms([...searchTerms, '']);
    };

    const removeRow = (index) => {
        if (menuItems.length > 1) {
            const newItems = menuItems.filter((_, i) => i !== index);
            const newSearchTerms = searchTerms.filter((_, i) => i !== index);
            setMenuItems(newItems);
            setSearchTerms(newSearchTerms);
        }
    };

    const updateSearchTerm = (index, value) => {
        const newSearchTerms = [...searchTerms];
        newSearchTerms[index] = value;
        setSearchTerms(newSearchTerms);
        
        const newItems = [...menuItems];
        newItems[index] = '';
        setMenuItems(newItems);
        
        setActiveDropdown(index);
    };

    const selectDish = (index, dish) => {
        const newItems = [...menuItems];
        const newSearchTerms = [...searchTerms];
        newItems[index] = dish._id;
        newSearchTerms[index] = dish.dishName;
        setMenuItems(newItems);
        setSearchTerms(newSearchTerms);
        setActiveDropdown(null);
    };

    const handleBlur = (index) => {
        setTimeout(() => {
            setActiveDropdown(null);
        }, 200);
    };

    const getFilteredDishes = (index) => {
        const searchTerm = searchTerms[index] || '';
        if (!searchTerm) return dishes;
        return dishes.filter(dish => 
            dish.dishName.toLowerCase().includes(searchTerm.toLowerCase())
        );
    };

    const handleSave = async () => {
        try {
            const validDishIds = dishes.map(d => d._id);
            const filteredMenu = menuItems.filter(item => {
                return item !== '' && validDishIds.includes(item);
            });
            
            if (filteredMenu.length === 0) {
                alert('Please select at least one dish from the dropdown.');
                return;
            }
            
            await updateMiqaatMenu({
                variables: {
                    miqaatId: miqaat._id,
                    menu: filteredMenu
                }
            });
            
            if (refetch) {
                await refetch();
            }
            
            onClose();
        } catch (err) {
            console.error('Error updating miqaat menu:', err);
            alert('Failed to update menu. Please try again.');
        }
    };

    return (
        <div className="menuFormOverlay" onClick={onClose}>
            <div className="menuFormCard" onClick={(e) => e.stopPropagation()}>
                <div className="menuFormHeader">
                    <h3>Menu for {miqaat.title}</h3>
                </div>
                <div className="menuFormBody">
                    <p className="menuNote">Enter the Mithaas, Khaaraas and/or Gravy, Side and Main</p>
                    
                    <div className="menuItemsList">
                        {menuItems.map((item, index) => (
                            <div key={index} className="menuItemRow">
                                <div className="typeaheadWrapper">
                                    <input
                                        type="text"
                                        value={searchTerms[index] || ''}
                                        onChange={(e) => updateSearchTerm(index, e.target.value)}
                                        onFocus={() => setActiveDropdown(index)}
                                        onBlur={() => handleBlur(index)}
                                        placeholder="Type to search dishes..."
                                        className="dishTypeahead"
                                    />
                                    {activeDropdown === index && searchTerms[index] && (
                                        <div className="typeaheadDropdown">
                                            {getFilteredDishes(index).length > 0 ? (
                                                getFilteredDishes(index).map(dish => (
                                                    <div
                                                        key={dish._id}
                                                        className="typeaheadOption"
                                                        onClick={() => selectDish(index, dish)}
                                                    >
                                                        {dish.dishName}
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="typeaheadNoResults">No dishes found</div>
                                            )}
                                        </div>
                                    )}
                                </div>
                                {menuItems.length > 1 && (
                                    <button
                                        className="removeRowButton"
                                        onClick={() => removeRow(index)}
                                        title="Remove dish"
                                    >
                                        −
                                    </button>
                                )}
                            </div>
                        ))}
                    </div>
                    
                    <button className="addRowButton" onClick={addRow}>
                        + Add Dish
                    </button>
                    
                    <div className="menuFormActions">
                        <button className="menuFormCloseButton" onClick={onClose}>
                            Close
                        </button>
                        <button className="menuFormSaveButton" onClick={handleSave}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MiqaatMenuForm;

